import { HeightCalculator } from "../helpers/height-calculator";

export class TopNav {
	init() {
		const navGroups =
			document.querySelectorAll<HTMLElement>(".nav-group");

		navGroups.forEach(navGroup => {
			const navElement = navGroup.querySelector("nav");

			if (navElement === null) {
				return;
			}

			const computedHeight = HeightCalculator.ComputeHeight(navElement);

			navElement.style.height = `${computedHeight}px`;
		});
	}
}

document.addEventListener("DOMContentLoaded", () => {
	const topNav = new TopNav();
	topNav.init();
});
